module.exports = __webpack_public_path__ + "afc3112d0f28f5bb84b0b56fb7438e43.fbx";